import {
  useState,
  useEffect,
  useCallback,
} from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";

export default function Stopwatch() {

  const [time, setTime] =
    useState(0);

  const [running, setRunning] =
    useState(false);

  const [laps, setLaps] =
    useState([]);

  /* FORMAT TIME */

  const formatTime =
    (milliseconds) => {

      const mins =
        Math.floor(
          milliseconds / 60000
        );

      const secs =
        Math.floor(
          (milliseconds % 60000) / 1000
        );

      const ms =
        Math.floor(
          (milliseconds % 1000) / 10
        );

      return `${String(mins).padStart(
        2,
        "0"
      )}:${String(secs).padStart(
        2,
        "0"
      )}:${String(ms).padStart(
        2,
        "0"
      )}`;
    };

  /* RESET */

  const resetTimer = () => {

    setRunning(false);

    setTime(0);

    setLaps([]);

  };

  /* LAP */

  const addLap =
    useCallback(() => {

      if (running) {

        setLaps((prev) => [
          ...prev,
          formatTime(time),
        ]);

      }

    }, [running, time]);

  /* TIMER */

  useEffect(() => {

    let interval;

    if (running) {

      interval = setInterval(() => {

        setTime(
          (prev) => prev + 10
        );

      }, 10);

    }

    return () =>
      clearInterval(interval);

  }, [running]);

  /* KEYBOARD SHORTCUTS */

  useEffect(() => {

    const handleKey =
      (e) => {

        if (e.code === "Space") {

          e.preventDefault();

          setRunning(
            (prev) => !prev
          );

        }

        if (
          e.key.toLowerCase() === "r"
        ) {

          resetTimer();

        }

        if (
          e.key.toLowerCase() === "l"
        ) {

          addLap();

        }

      };

    window.addEventListener(
      "keydown",
      handleKey
    );

    return () =>
      window.removeEventListener(
        "keydown",
        handleKey
      );

  }, [addLap]);

  return (
    <>
      <SEO
        title="Online Stopwatch Timer"
        description="Free online stopwatch with lap timer, milliseconds, and keyboard shortcuts."
      />

      <Navbar />

      <div
        className="container-fluid"
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(135deg,#111827,#1f2937)",
          color: "white",
          paddingTop: "40px",
          paddingBottom: "40px",
        }}
      >

        <div className="row justify-content-center">

          <div className="col-lg-8">

            <div
              className="card border-0 shadow-lg rounded-4 text-center p-5"
              style={{
                background:
                  "rgba(255,255,255,0.05)",
                backdropFilter:
                  "blur(10px)",
                color: "white",
              }}
            >

              <h1 className="fw-bold mb-3">
                Online Stopwatch
              </h1>

              <p className="text-light mb-5">
                Professional stopwatch
                with milliseconds
                and lap timer.
              </p>

              {/* TIMER */}

              <div
                className="display-1 fw-bold mb-5"
                style={{
                  letterSpacing: "4px",
                }}
              >
                {formatTime(time)}
              </div>

              {/* BUTTONS */}

              <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">

                <button
                  className={`btn btn-lg px-5 ${
                    running
                      ? "btn-danger"
                      : "btn-success"
                  }`}
                  onClick={() =>
                    setRunning(
                      !running
                    )
                  }
                >
                  {running
                    ? "Pause"
                    : "Start"}
                </button>

                <button
                  className="btn btn-warning btn-lg px-5"
                  onClick={addLap}
                >
                  Lap
                </button>

                <button
                  className="btn btn-light btn-lg px-5"
                  onClick={resetTimer}
                >
                  Reset
                </button>

              </div>

              {/* SHORTCUTS */}

              <div className="mb-4">

                <span className="badge bg-dark me-2 p-2">
                  SPACE = Start/Pause
                </span>

                <span className="badge bg-dark me-2 p-2">
                  L = Lap
                </span>

                <span className="badge bg-dark p-2">
                  R = Reset
                </span>

              </div>

              {/* LAPS */}

              {laps.length > 0 && (

                <div
                  className="mt-4 text-start"
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >

                  <h3 className="fw-bold mb-3">
                    Lap Times
                  </h3>

                  <div className="list-group">

                    {laps
                      .slice()
                      .reverse()
                      .map(
                        (
                          lap,
                          index
                        ) => (

                          <div
                            key={index}
                            className="list-group-item bg-dark text-white border-secondary d-flex justify-content-between"
                          >

                            <span>
                              Lap{" "}
                              {
                                laps.length -
                                index
                              }
                            </span>

                            <strong>
                              {lap}
                            </strong>

                          </div>

                        )
                      )}

                  </div>

                </div>

              )}

            </div>

          </div>

        </div>

      </div>

      <Footer />

    </>
  );
}